import { render, staticRenderFns } from "./PublicGroupCard.vue?vue&type=template&id=d9d4aa72&scoped=true&"
import script from "./PublicGroupCard.vue?vue&type=script&lang=ts&"
export * from "./PublicGroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./PublicGroupCard.vue?vue&type=style&index=0&id=d9d4aa72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d4aa72",
  null
  
)

export default component.exports